import { IApiError } from '@/models/apiError.model';
import { IUser } from '@/models/user.model';

export const PROFILE_SLICE_NAME = 'profile';

export interface ProfileState {
  profile: IUser | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: ProfileState = {
  profile: null,
  isLoading: false,
  error: null,
};
